<template>
  <div class="stats">
    <nav class="level is-mobile">
      <div
        class="level-item has-text-centered"
        v-if="permissions.seeProducts && !store.storeInfo.vendingsOnly"
      >
        <div>
          <p class="heading" @click="storeProducts">
            <a>{{ $t("dashboard.products") }}</a>
          </p>

          <p class="title has-cursor-pointer" @click="storeProducts">
            {{ store.productsQty + store.scaleProductsQty }}
          </p>
        </div>
      </div>

      <div
        class="level-item has-text-centered"
        v-if="
          permissions.seeAccessesPage &&
            !store.storeInfo.vendingsOnly &&
            ((store.accessDevices && store.accessDevices.length) ||
              store.equipments.length > 0)
        "
      >
        <div>
          <p class="heading" @click="storeAccesses">
            <a>{{ $t("dashboard.accesses") }}</a>
          </p>

          <p class="title has-cursor-pointer" @click="storeAccesses">
            {{ store.accessesQty }}
          </p>
        </div>
      </div>

      <div
        class="level-item has-text-centered"
        v-if="permissions.seeTransactionsPage"
      >
        <div>
          <p class="heading" @click="storeTransactions">
            <a>{{ $t("dashboard.transactions") }}</a>
          </p>

          <p class="title has-cursor-pointer" @click="storeTransactions">
            {{ store.transactionsQty }}
          </p>
        </div>
      </div>
    </nav>

    <nav class="level is-mobile">
      <div
        class="level-item has-text-centered"
        v-if="store.vendings && store.vendings.length > 0"
      >
        <div>
          <p class="heading" @click="storeVendings">
            <a>{{ $t("dashboard.vendings") }}</a>
          </p>

          <p class="title has-cursor-pointer" @click="storeVendings">
            {{ store.vendings.length }}
          </p>
        </div>
      </div>

      <div
        class="level-item has-text-centered"
        v-if="store.configs.orders && permissions.seeOrders"
      >
        <div>
          <p class="heading" @click="orders">
            <a>{{ $t("dashboard.orders") }}</a>
          </p>

          <p class="title has-cursor-pointer" @click="orders">
            {{ store.ordersQty }}
          </p>
        </div>
      </div>

      <div
        class="level-item has-text-centered"
        v-if="permissions.seeFeedbacksPage"
      >
        <div>
          <p class="heading" @click="storeFeedbacks">
            <a>{{ $t("dashboard.feedbacks") }}</a>
          </p>

          <p class="title has-cursor-pointer" @click="storeFeedbacks">
            {{ store.feedbacksQty }}
          </p>
        </div>
      </div>
    </nav>

    <nav class="level is-mobile">
      <div
        class="level-item has-text-centered"
        v-if="
          store.configs.hasBags &&
            (permissions.canManageBag || permissions.canManageBagProducts)
        "
      >
        <div>
          <p class="heading" @click="bags">
            <a>{{ $t("dashboard.bags") }}</a>
          </p>

          <p class="title has-cursor-pointer" @click="bags">
            {{ store.bagsQty }}
          </p>
        </div>
      </div>
      <!-- <div
        class="level-item has-text-centered"
        v-if="store.totems && store.totems.length > 0"
      >
        <div>
          <p class="heading" @click="totems">
            <a>{{ $t("dashboard.totems") }}</a>
          </p>

          <p class="title has-cursor-pointer" @click="totems">
            {{ store.totems.length }}
          </p>
        </div>
      </div> -->
    </nav>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { common } from "../../../mixins/common";

export default {
  props: ["store"],

  mixins: [common],

  methods: {
    storeProducts() {
      this.$store
        .dispatch("setStoreBeingManaged", this.store)
        .then(() => {
          this.$router.push("/products");
        })
        .catch(() => {
          this.alertError({ message: "UNEXPECTED_ERROR" });
        });
    },

    storeAccesses() {
      this.$store
        .dispatch("setStoreBeingManaged", this.store)
        .then(() => {
          this.$router.push("/accesses");
        })
        .catch(() => {
          this.alertError({ message: "UNEXPECTED_ERROR" });
        });
    },

    storeTransactions() {
      this.$store
        .dispatch("setStoreBeingManaged", this.store)
        .then(() => {
          this.$router.push("/transactions");
        })
        .catch(() => {
          this.alertError({ message: "UNEXPECTED_ERROR" });
        });
    },

    storeFeedbacks() {
      this.$store
        .dispatch("setStoreBeingManaged", this.store)
        .then(() => {
          this.$router.push("/feedbacks");
        })
        .catch(() => {
          this.alertError({ message: "UNEXPECTED_ERROR" });
        });
    },

    storeVendings() {
      this.$store
        .dispatch("setStoreBeingManaged", this.store)
        .then(() => {
          this.$router.push("/vendings");
        })
        .catch(() => {
          this.alertError({ message: "UNEXPECTED_ERROR" });
        });
    },

    orders() {
      this.$store
        .dispatch("setStoreBeingManaged", this.store)
        .then(() => {
          this.$router.push("/orders");
        })
        .catch(() => {
          this.alertError({ message: "UNEXPECTED_ERROR" });
        });
    },

    bags() {
      this.$store
        .dispatch("setStoreBeingManaged", this.store)
        .then(() => {
          this.$router.push("/bags");
        })
        .catch(() => {
          this.alertError({ message: "UNEXPECTED_ERROR" });
        });
    },

    totems() {
      this.$store
        .dispatch("setStoreBeingManaged", this.store)
        .then(() => {
          this.$router.push("/totems");
        })
        .catch(() => {
          this.alertError({ message: "UNEXPECTED_ERROR" });
        });
    }
  },

  computed: {
    ...mapGetters(["permissions"])
  }
};
</script>

<style scoped>
.stats {
  margin: auto;
  margin-top: 1.5rem;
}
.has-cursor-pointer {
  cursor: pointer;
}
</style>
